<script>
import CompList from '@render-core/comp-list';
import API from '@apis/ares';
import { AresConverter, Share } from '@shared/interface';
import Navigation from './navigation.vue';
import _get from 'lodash/get';
import jsBridge from '@/utils/jsBridge';

import htmlUtil from '@/utils/html_util';
import AresGlobal from '@shared/utils/ares_global';
import styleTransform from '@shared/utils/styleTransform';

const ACT_STATUS = {
  UNSTART: 1,
  ACTIVE: 2,
  OVERDUE: 3,
};

export default {
  props: {
    aresInfo: {
      type: Object,
    },
    aresYamlReceived: Function,
    aresYamlFail: Function,
  },
  data() {
    const { PageID, PackageID, ConfID, Version, PreviewTime } = this.aresInfo;
    return {
      // 导航数据
      navInfoStore: {
        beginList: [],
        endList: [],
        compIdList: [],
        current: {
          compId: null,
        },
      },
      compList: [],
      inNavComList: [],
      pageStyle: {},
      RawData: null,
      ActivityStatus: null,
      isLoading: true,
      PageID, PackageID, ConfID, Version, PreviewTime,
      pageInfo: null,
    };
  },
  provide() {
    return {
      navInfoStore: this.navInfoStore,
      isPreview: this.isPreview,
    };
  },
  created() {
    this.isPreview = Boolean(this.PreviewTime);

    this.getDetail();
    this.hideNavigationBar({ status: 0 });
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    async hideNavigationBar(config) {
      try {
        await jsBridge.ares.hideNavBar(config);
        this.hasHideNav = true;
      } catch (err) {
        this.hasHideNav = false;
      }
    },
    toHome() {
      this.$AresRouter.go({ route: 'home', el: this.$el });
    },
    handleScroll() {
      const { beginList, endList, compIdList, current } = this.navInfoStore || {};
      const { compId } = current;
      if (beginList.length === 0) return;
      const y = document.documentElement.scrollTop || document.body.scrollTop;
      const top = y + 40;
      for (let i = 0, count = beginList.length; i < count; i++) {
        if (beginList[i] <= top && top < endList[i]) {
          if (compId !== compIdList[i]) {
            this.$set(this.navInfoStore, 'current', {
              compId: compIdList[i],
              compIndex: i,
            });
            break;
          }
        }
      }
    },
    getDetail() {
      if (this.PageID) {
        this.getDetailByPageID();
      } else if (this.ConfID) {
        this.getDetailByConfID();
      } else {
        this.$Logger.sendLogicError(128002, 'ares_h5', 'Ares 没有指定页面ID');
        return alert('请指定PageID或者ConfID!');
      }
    },
    // 通过 PageID 来获取页面信息
    getDetailByPageID() {
      const { PageID, PackageID, PreviewTime } = this;

      const params = { PageID, PackageID };
      let PageFetcher = API.getDetail;
      // 优先使用注入数据
      if (window.aresInjectData && window.aresInjectData.Page) {
        PageFetcher = this.aresInjectDataGetter;
      } else if (this.isPreview) {
        params.PreviewTime = PreviewTime;
        if (this.Version) params.Version = this.Version;
        // 预览草稿1
        // 预览正式2
        params.PreviewType = 1;
        PageFetcher = API.getPreviewDetail;
      }
      this.doFetch(PageFetcher, params);
    },
    getDetailByConfID() {
      const { ConfID, PreviewTime } = this;

      const params = { ConfID };
      let PageFetcher = API.getDetailByConfID;
      // 优先使用注入数据
      if (window.aresInjectData && window.aresInjectData.Page) {
        PageFetcher = this.aresInjectDataGetter;
      } else if (this.isPreview) {
        params.PreviewTime = PreviewTime;
        // 预览草稿1
        // 预览正式2
        params.PreviewType = 1;
        PageFetcher = API.getPreviewDetailByConfID;
      }
      this.doFetch(PageFetcher, params);
    },
    aresInjectDataGetter() {
      return new Promise((resolve, reject) => {
        // 直接从本地取 YAML Data
        const injectData = window.aresInjectData;
        resolve(injectData);
      });
    },
    // 获取 Ares 详细方法
    doFetch(PageFetcher, params) {
      PageFetcher(params).then((res) => {
        const pageData = res.Page || {};
        this.aresProcess(pageData);
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.isLoading = false;
        });;
    },
    aresProcess(data) {
      const { ActivityStatus, Data = '', ...restInfo } = data || {};

      // 不存在 ActivityStatus 的时候, 使用客户端时间判断活动状态
      if (!ActivityStatus) {
        const curTime = new Date().getTime();
        if (curTime < restInfo.EndTime && curTime > restInfo.StartTime) {
          // 活动有效
          this.ActivityStatus = ACT_STATUS.ACTIVE;
        } else if (curTime > restInfo.EndTime) {
          // 活动过期
          this.ActivityStatus = ACT_STATUS.OVERDUE;
        } else {
          // 活动未开始
          this.ActivityStatus = ACT_STATUS.UNSTART;
        }
      } else {
        this.ActivityStatus = ActivityStatus;
      }

      this.pageInfo = restInfo;
      // json parse操作容易出错，做兜底和错误上报
      this.RawData = AresConverter.loadAresData(Data);
      this.aresYamlReceived(this.RawData, restInfo);

      if (this.RawData && this.RawData.root) {
        const { style = {}, children = [], conf = {} } = this.RawData.root || {};
        this.pageStyle = style;
        this.compList = AresConverter.loadChildren(children);

        document.title = this.pageInfo.Name;
        Share.config(conf.share || {});
        this.downloadConfig = conf.download;

        const globalData = _get(this.RawData, 'root.global');
        if (globalData) {
          AresGlobal.getInstance().set(globalData);
        }
      }
    },
    renderDownloadMask(config) {
      if (!config || !config.disable) {
        return null;
      }
      return <div class="download-mask" vOn:click={this.onClickDownload} />;
    },
    onClickDownload() {
      this.setClipboard(this.downloadConfig.clipboard);
      const platform = htmlUtil.platform();
      window.location.href = this.downloadConfig[platform] || this.downloadConfig.android;
    },
    setClipboard(message = '') {
      htmlUtil.clipboard.write(`YZchannelId:${message}`);
    },

    renderEmpty() {
      const {  ActivityStatus, toHome } = this;

      this.$Logger.sendLogicInfo('ares_h5', 'Ares 渲染了空页面', {
        PageID: this.PageID,
        ActivityStatus,
      });

      return <div class="empty-wrap">
        <img src={require('../image/activity_over.png')} alt=""/>
        <p class="text">
          {ActivityStatus === 1 ? '你来早了哦 活动还没开始 去逛逛首页吧' : ''}
          {ActivityStatus === 3 ? '活动已结束 去逛逛首页吧' : ''}
        </p>
        <p class="to-home" on={{ click: toHome }}>逛逛首页</p></div>;
    },
    renderCompList({ item, children }) {
      const list = children;
      if (!list) return null;

      const options = {
        props: {
          list,
          pageInfo: this.pageInfo,
          pageConfig: this.RawData,
        },
        scopedSlots: {
          // 递归渲染子列表
          children: this.renderCompList,
        },
      };
      return list && list.length > 0
        ? <CompList {...options}></CompList> : null;
    },

    renderNavigation() {
      const fullScreen = _get(this.RawData, 'root.conf.navigation.fullScreen', '');
      const darkMode = _get(this.RawData, 'root.conf.navigation.darkMode', false);
      const show = fullScreen && this.hasHideNav;
      if (show) {
        this.hideNavigationBar({
          status: 1,
          theme: darkMode ? 'dark' : 'light',
        });
        return <Navigation dark-mode={darkMode}/>;
      }
      return null;
    },

    renderAres() {
      const {  inNavComList, compList, downloadConfig } = this;
      const formatStyle = styleTransform.getStyle(this.pageStyle);

      return <div style={formatStyle} class="wrap" id="ares-list-wrapper">
        {
          this.renderNavigation()
        }
        {
          this.renderCompList({ children: compList })
        }
        {
          this.renderDownloadMask(downloadConfig)
        }
      </div>;
    },

  },
  render() {
    const { isLoading, ActivityStatus } = this;
    if (isLoading) return null;
    if (ActivityStatus === 2) return this.renderAres();
    return this.renderEmpty();
  },
};
</script>

<style scoped lang="scss">
.wrap{
  min-height: 100%;
  // overflow开了之后 里面组件的position:sticky会失效
  // overflow: auto;
}
.download-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0;
  left: 0;
}
.empty-wrap{
  display: flex;
    flex-direction: column;
    // justify-content: center;

    align-items: center;
    font-size: 14px;
    img{
      width: 100%;
      margin-top: 150px;
    }
    .text{
      color: #1F1F1F;

    }
    .to-home{
      border: 1px solid #FC3941;
      color:#FC3941;
      border-radius: 15px;
      padding: 9px 12px;
      margin-top: 9px;
    }
}
</style>
